import { render, staticRenderFns } from "./scenarios.vue?vue&type=template&id=28ce0496&scoped=true&"
import script from "./scenarios.vue?vue&type=script&lang=js&"
export * from "./scenarios.vue?vue&type=script&lang=js&"
import style0 from "./scenarios.vue?vue&type=style&index=0&id=28ce0496&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ce0496",
  null
  
)

export default component.exports